(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Reserves', Reserves);

    Reserves.$inject = ['$resource'];

    function Reserves ($resource) {
        var resourceUrl =  'api/reserves/:path/:id';

        return $resource(resourceUrl, {}, {
            'create': {
                method: 'POST',
                isArray: false
            },
            'update': {
                method:'PUT',
                isArray: false
            },
            'delete': {
                method:'DELETE'
            } ,
            'page': {
                method:'GET',
                isArray: true
            },
            'detail': {
                method:'GET'
            },
            'getAll': {
                method:'GET',
                isArray: true,
                params: {
                    path: 'getAll'
                }
            },
            'getHomePageData': {
                method:'GET',
                params: {
                    path: 'getHomePageData'
                }
            },
            
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAllReserveByType': {
                method: 'GET',
                params: {
                    path: 'getAllReserveByType'
                },
                isArray: true
            },
            'getByWarehouseAndProductNumber': {
                method: 'GET',
                params: {
                    path: 'getByWarehouseAndProductNumber'
                }
            }

        });
    }

})();
